import { CSSProperties, useState } from 'react';

export interface IYoutubeEmbed {
  embedId: string;
  style?: CSSProperties;
  className?: string;
}

/**
 * Simple YouTube iframe that keeps 16:9 using the native CSS `aspect-ratio`
 * property — no Tailwind plugin required.
 */
const YoutubeEmbed = ({
  embedId,
  style = {},
  className = '',
}: IYoutubeEmbed) => {
  const [active, setActive] = useState(false);

  if (active) {
    return (
      <iframe
        className={className}
        style={{
          width: '100%',
          aspectRatio: '16 / 9',
          border: 0,
          ...style,
        }}
        src={`https://www.youtube-nocookie.com/embed/${embedId}?controls=0`}
        title="Getting-Started video"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        loading="lazy"
      />
    );
  }

  const thumbnail = `https://img.youtube.com/vi/${embedId}/hqdefault.jpg`;

  return (
    <button
      type="button"
      className={className}
      style={{
        width: '100%',
        aspectRatio: '16 / 9',
        backgroundImage: `url(${thumbnail})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        border: 0,
        cursor: 'pointer',
        ...style,
      }}
      onClick={() => setActive(true)}
      aria-label="Play video"
    />
  );
};

export default YoutubeEmbed;
